import React from 'react'

class Navigation extends React.Component {

  activeClass(isActive) {
    return (isActive ? "active" : "");
  }

  renderCircle(active) {
    let circleClass = `list-inline-item ${this.activeClass(active)}`
    return (
      <li className={circleClass}>
        <div className='fa fa-circle' />
      </li>
    )
  }

  // https://trello.com/c/D1Mou2wA - Do not show dots if its the last step.
  renderCircles () {
    let { step } = this.props

    if (step == 6) {
      return(null);
    }

    return (
      <ul className='list-inline'>
        {this.renderCircle(step >= 1) }
        {this.renderCircle(step >= 2) }
        {this.renderCircle(step >= 3) }
        {this.renderCircle(step >= 4) }
        {this.renderCircle(step == 5) }
        {this.renderCircle(step == 6) }
      </ul>
    )
  }

  render() {
    return (
      <div className='indicator step-indicators'>
        { this.renderCircles() }
      </div>
    )
  }
}

export default Navigation;
